import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Trang Chủ', path: '/' },
    { name: 'Văn', path: '/van' },
    { name: 'Toán', path: '/toan' },
    { name: 'Lý', path: '/ly' },
    { name: 'Hóa', path: '/hoa' },
    { name: 'Tin Tức', path: '/tin-tuc' },
    { name: 'Liên Hệ', path: '/lien-he' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm transition-all ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-amber-500 rounded-lg flex items-center justify-center">
              <i className="ri-graduation-cap-fill text-white text-xl"></i>
            </div>
            <h1 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Merriweather, serif' }}>
              HọcThôngMinh.vn
            </h1>
          </a>

          {/* Navigation Menu */}
          <ul className="hidden lg:flex items-center gap-8 text-sm font-medium">
            <li>
              <a href="/" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">
                Trang chủ
              </a>
            </li>
            
            {/* Môn học Dropdown */}
            <li className="relative group">
              <button className="flex items-center gap-1 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">
                Môn học
                <i className="ri-arrow-down-s-line"></i>
              </button>
              <ul className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                <li>
                  <a href="/van" className="flex items-center gap-2 px-4 py-3 hover:bg-orange-50 transition-colors cursor-pointer">
                    <i className="ri-book-open-fill text-red-500"></i>
                    <span>Văn học</span>
                  </a>
                </li>
                <li>
                  <a href="/toan" className="flex items-center gap-2 px-4 py-3 hover:bg-orange-50 transition-colors cursor-pointer">
                    <i className="ri-function-line text-blue-600"></i>
                    <span>Toán học</span>
                  </a>
                </li>
                <li>
                  <a href="/ly" className="flex items-center gap-2 px-4 py-3 hover:bg-orange-50 transition-colors cursor-pointer">
                    <i className="ri-flashlight-fill text-orange-500"></i>
                    <span>Vật lý</span>
                  </a>
                </li>
                <li>
                  <a href="/hoa" className="flex items-center gap-2 px-4 py-3 hover:bg-orange-50 transition-colors cursor-pointer">
                    <i className="ri-test-tube-fill text-purple-600"></i>
                    <span>Hóa học</span>
                  </a>
                </li>
              </ul>
            </li>

            {/* Lớp học Dropdown */}
            <li className="relative group">
              <button className="flex items-center gap-1 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">
                Lớp học
                <i className="ri-arrow-down-s-line"></i>
              </button>
              <ul className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                <li>
                  <a href="#cap-2" className="block px-4 py-3 hover:bg-orange-50 transition-colors cursor-pointer">
                    Cấp 2 (Lớp 6-9)
                  </a>
                </li>
                <li>
                  <a href="#cap-3" className="block px-4 py-3 hover:bg-orange-50 transition-colors cursor-pointer">
                    Cấp 3 (Lớp 10-12)
                  </a>
                </li>
              </ul>
            </li>

            <li>
              <a href="#luyen-thi" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">
                Luyện thi
              </a>
            </li>
            
            <li>
              <a href="#cong-thuc" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">
                Công thức
              </a>
            </li>

            <li>
              <a href="/tin-tuc" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">
                Tin tức
              </a>
            </li>
          </ul>

          {/* Search Box */}
          <div className="hidden md:flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-full">
            <input
              type="text"
              placeholder="Tìm bài học, công thức..."
              className="bg-transparent outline-none text-sm w-48"
            />
            <button className="cursor-pointer">
              <i className="ri-search-line text-gray-600"></i>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden text-2xl text-gray-700 cursor-pointer">
            <i className="ri-menu-line"></i>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
